// @ts-strict-ignore
import { inject, singleton } from "tsyringe";
import { WINDOW } from "../symbols";
import { StorageAdapter } from "./storage-adapter";

@singleton()
export class SessionStorage {
  private readonly storageAdapter: StorageAdapter;

  constructor(
    @inject(WINDOW)
    window: Window,
  ) {
    this.storageAdapter = new StorageAdapter(window.sessionStorage);
  }

  getItem<T>(key: string): T | string {
    return this.storageAdapter.getItem<T>(key);
  }

  setItem(key: string, input: Dictionary | string): void {
    try {
      this.storageAdapter.setItem(key, input);
    } catch (e) {
      // SessionStorage not available or full
    }
  }

  removeItem(key: string): void {
    return this.storageAdapter.removeItem(key);
  }
}
